import React, { Component } from 'react';
import classNames from 'classnames';
import Paging from './common/Paging.react.js';
let i18n = require("i18next");

export default class Overview extends Component {
    render() {
        let demoButton = this.props.showDemoBtn ?
            <button className="pull-right generateDemoData btn btn-success">{i18n.t("pos.generate.demo.data")}</button> :
            null;

        return (
            <div id="overview" className={classNames('state', {experienceRestaurantDialogBottom: this.props.isExp})}>
                <div>
                    <div className="tableFilter">

                        <div className="colourCode">
                            <div className="all filter selected vcenter"><span className="all"></span>
                                <div className="never-allow">{i18n.t("pos.status.all")}</div>
                                <div className="activeStyle"></div></div>

                            <div className="filter vcenter"><span className="paid mark"></span>
                                <div className="never-allow">{i18n.t("pos.status.paid")}</div>
                                <div className="activeStyle"></div></div>

                            <div className="filter vcenter"><span className="unpaid mark"></span>
                                <div className="never-allow">{i18n.t("pos.status.unpaid")}</div>
                                <div className="activeStyle"></div></div>

                            <div className="filter vcenter">
                                <span className="closed mark"></span>
                                <div className="never-allow">{i18n.t("pos.status.closed")}</div>
                                <div className="activeStyle"></div>
                            </div>
                        </div>

                        <span className="page-col">
                            <Paging />
                        </span>

                        <button className="pull-right mobile-order btn btn-success">{i18n.t("pos.status.mobile.order")}</button>
                        <div className="pull-right clear-table">{i18n.t("pos.status.clear")}</div>
                        {demoButton}
                    </div>

                    <div className="tooieIconBack">
                        <img src={require('../images/overview/tooieIconBack.png')}/>
                    </div>

                    <div className="tableList">
                    </div>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/react/Overview.react.js